// Angular
import { Injectable } from '@angular/core';
// Object-Path
import * as objectPath from 'object-path';
// RxJS
import { Subject } from 'rxjs';
import { LanguageType } from 'src/metronic/core/_config/i18n/language-type.model';
// Models
import { LayoutConfigModel } from '../models/layout-config.model';

@Injectable()
export class LayoutConfigService {
  // Public properties
  onConfigUpdated$: Subject<LayoutConfigModel>;
  layoutConfig: LayoutConfigModel;

  /**
   * Servcie constructor
   */
  constructor() {
    // register on config changed event and set default config
    this.onConfigUpdated$ = new Subject();
  }

  /**
   * Get all config or by object path
   * @param path | object path separated by dot
   */
  getConfig(path?: string): LayoutConfigModel | any {
    // merge default layout config with the saved config from layout storage
    // @todo; known issue; viewing 2 or more demos at the time in different browser's tabs, can cause conflict to the layout config
    if (path) {
      // if path is specified, get the value within object
      return objectPath.get(this.layoutConfig, path);
    }

    return this.layoutConfig;
  }

  /**
   * Get brand logo
   */
  getLogo(languageType: LanguageType, isSmall: boolean = false): string {
    const menuAsideLeftSkin = objectPath.get(this.layoutConfig, 'brand.self.skin');
    const logoConfigPath = `self.logo${isSmall ? 'Sm' : ''}`;

    // set brand logo
    const logoObject = objectPath.get(this.layoutConfig, logoConfigPath);

    let logo: string;
    if (typeof logoObject === 'string') {
      logo = logoObject;
    }
    if (typeof logoObject === 'object') {
      logo = objectPath.get(logoObject, menuAsideLeftSkin + '');
    }
    if (typeof logo === 'undefined') {
      try {
        const logos = objectPath.get(this.layoutConfig, logoConfigPath);
        logo = logos[Object.keys(logos)[0]];
      } catch (e) {
      }
    }

    return this.createLogoName(logo, languageType);
  }

  getLoaderLogo(languageType: LanguageType): string {
    const logo = objectPath.get(this.getConfig('loader'), 'logo');
    return this.createLogoName(logo, languageType);
  }

  /**
   * Returns sticky logo
   */
  getStickyLogo(languageType: LanguageType): string {
    let logo = objectPath.get(this.layoutConfig, 'self.logo.sticky');
    if (typeof logo === 'undefined') {
      logo = this.getLogo(languageType);
    }
    return this.createLogoName(logo, languageType);
  }

  /**
   * Initialize layout config
   * @param config
   */
  loadConfigs(config: LayoutConfigModel) {
    this.layoutConfig = null;
    // use saved config as priority, or load new config if demo does not matched
    if (!this.layoutConfig || objectPath.get(this.layoutConfig, 'demo') !== config.demo) {
      this.layoutConfig = config;
    }
  }

  private createLogoName(logo: string, languageType: LanguageType) {
    return `${logo}-${languageType}.png`;
  }
}
